import { ValidatorFn, ValidatorsMap } from '../validation-config';

const scenarioValidationKeyByCanonical: Record<string, string> = {
  asIs: 'asIsScenario',
  asCompleted: 'uponCompletionScenario',
  asStabilized: 'uponStabilizationScenario',
  uponCompletion: 'uponCompletionScenario',
  uponStabilization: 'uponStabilizationScenario'
};

const normalizeScenarioValue = (value: any): string =>
  (value ?? '').toString().trim().toLowerCase().replace(/[^a-z0-9]/g, '');

export function getValueByPath(data: any, path: string): any {
  return path.split('.').reduce((o, k) => o?.[k], data);
}

export function canonicalizeValuationScenario(scenarioRaw: any, valueConditionRaw: any): string | null {
  const scenario = normalizeScenarioValue(scenarioRaw);
  const valueCondition = normalizeScenarioValue(valueConditionRaw);

  if (scenario === 'asis' || valueCondition === 'asis') return 'asIs';
  if (scenario === 'ascompleted' || valueCondition === 'ascompleted') return 'asCompleted';
  if (scenario === 'asstabilized' || valueCondition === 'asstabilized') return 'asStabilized';
  if (scenario === 'uponcompletion' || valueCondition === 'uponcompletion') return 'uponCompletion';
  if (scenario === 'uponstabilization' || valueCondition === 'uponstabilization') return 'uponStabilization';

  return null;
}

export function getValuationScenarioValidationPath(canonicalScenario: string, metricKey: string): string | null {
  const scenarioKey = scenarioValidationKeyByCanonical[canonicalScenario];
  return scenarioKey ? `valuationSummary.${scenarioKey}.${metricKey}` : null;
}

export function getValuationScenarioValidator(canonicalScenario: string, metricKey: string): ValidatorFn | undefined {
  const validationPath = getValuationScenarioValidationPath(canonicalScenario, metricKey);
  return validationPath ? ValidatorsMap[validationPath] : undefined;
}

export function isRowInvalid(
  data: any,
  lookupValues?: { [key: string]: string[] }
): boolean {
  const hasInvalidMappedField = Object.keys(ValidatorsMap).some(path => {
    const result = ValidatorsMap[path](getValueByPath(data, path), lookupValues);
    return !result.valid;
  });

  if (hasInvalidMappedField) {
    return true;
  }

  const scenarios = data?.valuationSummary?.scenarios;
  if (!Array.isArray(scenarios)) {
    return false;
  }

  return scenarios.some((scenario: any) => {
    const canonicalScenario = canonicalizeValuationScenario(scenario?.scenario, scenario?.valueCondition);
    if (!canonicalScenario) {
      return false;
    }

    return Object.keys(scenario).some(metricKey => {
      const validator = getValuationScenarioValidator(canonicalScenario, metricKey);
      if (!validator) {
        return false;
      }

      return !validator(scenario[metricKey], lookupValues).valid;
    });
  });
}
